export const detail = {
  table: {
    id: '順番',
    detergentName: '洗剤名',
    quantity: '洗剤量/ml',
    timeUnit: '分',
    unit: '単位',
    method: '洗浄プログラム',
    detergentUsed: '使用洗剤',
    time: '洗浄時間',
    washingTime: '洗浄時間',
    customer: '顧客',
    customerCode: '納入先CD',
    customerName: '顧客名',
  },
  pageHeader: {
    title: '洗浄プログラムリスト　洗浄プログラム詳細画面',
  },
}
